var _defs, _circle, _polygon, _polygon2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlassDoor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1292ee;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.16,
    cy: 40.11,
    r: 2.03
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "14.1 66.51 13.74 12.01 35.84 19.46 34.16 19.83 14.82 13.45 15.16 65.11 42.45 57.69 42.45 20.54 43.52 20.1 43.52 58.51 14.1 66.51"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.76 66.5 42.5 59.65 44.55 59.31 62.69 65.11 62.69 13.79 35.47 21.33 35.47 58.57 34.4 59.14 34.4 20.51 63.76 12.37 63.76 66.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35.18,
    y: 38.73,
    width: 28.04,
    height: 1.07
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassDoor2);
export default __webpack_public_path__ + "static/media/glassDoor2.261cd0705cee971b6cff8cb3e6bf4c3c.svg";
export { ForwardRef as ReactComponent };